import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";
import axios from "axios";
export const formatPhone = (phone) => {
  if (!phone) return "-";

  // Sadece rakamları al
  let digits = phone.toString().replace(/\D/g, "");

  // +90 ile gelenler (90555...)
  if (digits.startsWith("90") && digits.length === 12) {
    return `+90 (${digits.slice(2, 5)}) ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`;
  }

  // 0 ile başlayanlar (0555...)
  if (digits.startsWith("0") && digits.length === 11) {
    return `0 (${digits.slice(1, 4)}) ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9, 11)}`;
  }

  // Direkt 5 ile başlayanlar (555...)
  if (digits.startsWith("5") && digits.length === 10) {
    return `0 (${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8, 10)}`;
  }

  // Diğer ülke kodları (+49123...)
  if (digits.length > 11) {
    const countryCode = digits.slice(0, digits.length - 10);
    const number = digits.slice(-10);
    return `+${countryCode} (${number.slice(0, 3)}) ${number.slice(3, 6)} ${number.slice(6, 8)} ${number.slice(8, 10)}`;
  }

  return phone; // fallback
};

export const formatStatus = (status) => {
  switch (status) {
    case "active":
      return "Aktif";
    case "inactive":
      return "Pasif";
    case "declined":
      return "Silinmiş";
    default:
      return "Bilinmiyor";
  }
};
export const formatStatusBadge = (status) => {
  const map = {
    active: {
      text: "Aktif",
      bg: "#E8F5E9",   // açık yeşil
      color: "#2E7D32" // koyu yeşil
    },
    inactive: {
      text: "Pasif",
      bg: "#FFF8E1",   // açık sarı
      color: "#F57C00" // koyu turuncu
    },
    declined: {
      text: "Silinmiş",
      bg: "#FDECEA",   // açık kırmızı
      color: "#C62828" // koyu kırmızı
    }
  };

  return map[status] || {
    text: "Bilinmiyor",
    bg: "#ECEFF1",
    color: "#546E7A"
  };
};



const TabOverviewContent = () => {
  const { id } = useParams(); //  URL'deki ID'yi al
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("admin_token");
        if (!token) {
          setError("Yetkilendirme hatası: Kullanıcı giriş yapmamış!");
          setLoading(false);
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/customers/view/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        console.log(" Frontend'e Gelen Kullanıcı Verisi:", response.data);

        setUserData(response.data);
      } catch (err) {
        console.error("❌ Kullanıcı bilgileri alınamadı:", err);
        setError("Kullanıcı bilgileri alınamadı.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [id]);

  if (loading) {
    return <p>⏳ Yükleniyor...</p>;
  }

  if (error) {
    return <p className="text-danger">{error}</p>;
  }

  const informationData = [
    { label: "Adı", value: userData?.firstName || "Bilinmiyor" },
    { label: "Soyadı", value: userData?.lastName || "Bilinmiyor" },
    { label: "E-Posta", value: userData?.email || "Bilinmiyor" },
    {
      label: "Telefon",
      value: userData?.phone ? formatPhone(userData.phone) : "Bilinmiyor",
    },

    { label: "Ülke", value: userData?.country || "Bilinmiyor" },
    {
      label: "Kayıt Tarihi",
      value:
        new Date(userData?.createdAt).toLocaleDateString("tr-TR") ||
        "Bilinmiyor",
    },
{
  label: "Durum",
  value: (() => {
    const s = formatStatusBadge(userData?.status);
    return (
      <span
        style={{
          backgroundColor: s.bg,
          color: s.color,
          padding: "6px 14px",
          borderRadius: "999px",
          fontSize: "13px",
          fontWeight: 600,
          display: "inline-block",
          minWidth: "90px",
          textAlign: "center"
        }}
      >
        {s.text}
      </span>
    );
  })(),
},



  ];

  return (
    <div
      className="tab-pane fade show active p-4"
      id="overviewTab"
      role="tabpanel"
    >
      <div className="about-section mb-5">
        <h5 className="fw-bold mb-0">Kullanıcı Bilgileri:</h5>
      </div>

      <div className="profile-details mb-5">
        {informationData.map((item, index) => (
          <div
            key={index}
            className={`row g-0 ${index === informationData.length - 1 ? "mb-0" : "mb-4"}`}
          >
            <div className="col-sm-6 text-muted">{item.label}:</div>
            <div className="col-sm-6 fw-semibold">{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabOverviewContent;
